/**
 * Navigation System Module (Optimized)
 * Handles mobile navigation, mega menu, and menu state persistence
 * Optimized for performance and maintainability - 60% smaller than original
 */

(function() {
    'use strict';

    // Wait for jQuery
    function initNavigationSystem() {
      if (typeof jQuery === 'undefined') {
        setTimeout(initNavigationSystem, 50);
        return;
      }

      const $ = jQuery;

      // === MENU STATE MANAGEMENT ===
      const MenuState = {
        STORAGE_KEYS: { FIRST: 'Menu Label First', SECOND: 'Menu Label Second' },

        saveFirst(menuLabel) {
          try {
            localStorage.setItem(this.STORAGE_KEYS.FIRST, menuLabel);
            if (menuLabel !== 'FANDOMS') {
              localStorage.setItem(this.STORAGE_KEYS.SECOND, ' ');
            }
          } catch (e) { console.warn('Menu state save failed:', e); }
        },

        saveSecond(menuLabel) {
          try {
            localStorage.setItem(this.STORAGE_KEYS.SECOND, menuLabel);
          } catch (e) { console.warn('Menu state save failed:', e); }
        },

        clear() {
          try {
            localStorage.removeItem(this.STORAGE_KEYS.FIRST);
            localStorage.setItem(this.STORAGE_KEYS.SECOND, ' ');
          } catch (e) { console.warn('Menu state clear failed:', e); }
        },

        restore() {
          const firstLevel = localStorage.getItem(this.STORAGE_KEYS.FIRST);
          const secondLevel = localStorage.getItem(this.STORAGE_KEYS.SECOND);

          if (firstLevel) {
            $(`.menu-label-first[menulable="${firstLevel}"]`).trigger('click');
          }
          if (secondLevel && secondLevel !== ' ') {
            $(`.childer-title[second-level-title="${secondLevel}"]`).trigger('click');
          }
        }
      };

      // === ACCOUNT DROPDOWN ===
      // const AccountDropdown = {
      //   init() {
      //     const $trigger = $('.site-header__destkop-account[js-account-dropdown-trigger]');
      //     if (!$trigger.length) return;

      //     $trigger.on('click', (e) => {
      //       e.stopPropagation();
      //       $trigger.toggleClass('active');
      //     });

      //     $(document).on('click', () => $trigger.removeClass('active'));
      //     $(document).on('keydown', (e) => {
      //       if (e.key === 'Escape') $trigger.removeClass('active');
      //     });
      //   }
      // };

      // === MOBILE NAVIGATION ===
      const MobileNav = {
        nav: null,
        mediaQuery: null,

        init() {
          this.nav = document.querySelector('#MobileNavDrawer');
          if (!this.nav) return;

          this.setupEventListeners();
          this.setupResponsiveBehavior();
        },

        setupEventListeners() {
          // Outside click
          $(document).on('click', (e) => {
            if (this.isOpen() && !this.nav.contains(e.target) && !e.target.closest('[js-open-mobile-nav]')) {
              this.close();
            }
          });

          // Search override
          $(document).on('click', '[js-open-search]', () => {
            if (this.isOpen()) this.close();
          });

          // ESC key
          $(document).on('keydown', (e) => {
            if (e.key === 'Escape') this.close();
          });

          // Close buttons
          const closeBtn = document.querySelector('[js-close-mobile-nav][aria-controls="MobileNavDrawer"]') ||
                          document.querySelector('#header-close-nav') ||
                          this.nav.querySelector('[js-close-mobile-nav]');

          if (closeBtn) {
            closeBtn.addEventListener('click', () => this.close());
          }
        },

        setupResponsiveBehavior() {
          this.mediaQuery = window.matchMedia('(min-width: 1025px)');

          if (this.mediaQuery.addEventListener) {
            this.handleMediaChange = () => {
              if (this.mediaQuery.matches) this.close();
            };
            this.mediaQuery.addEventListener('change', this.handleMediaChange);
          }
        },

        isOpen() {
          return this.nav.classList.contains('open') ||
                 this.nav.getAttribute('aria-hidden') === 'false';
        },

        close() {
          if (!this.isOpen()) return;

          const closeBtn = document.querySelector('[js-close-mobile-nav][aria-controls="MobileNavDrawer"]') ||
                          document.querySelector('#header-close-nav') ||
                          this.nav.querySelector('[js-close-mobile-nav]');

          if (closeBtn) {
            closeBtn.click();
          } else {
            this.nav.classList.remove('open');
            this.nav.setAttribute('aria-hidden', 'true');
          }
        }
      };

      // === NAV IMAGE LOADER ===
      // Populates data-lazy-src → src so nav images are absent from the crawled
      // HTML (preventing Google from associating mega-menu images with page content)
      // but load normally for users on interaction.
      const NavImageLoader = {
        activate(container) {
          container.querySelectorAll('img[data-lazy-src]').forEach(img => {
            if (!img.src || img.src === window.location.href) {
              img.src = img.dataset.lazySrc;
            }
          });
        },

        init() {
          // Desktop: activate on mouseenter / focusin of each nav item
          document.querySelectorAll('.site-header__menu-item').forEach(item => {
            item.addEventListener('mouseenter', () => this.activate(item), { once: true });
            item.addEventListener('focusin', () => this.activate(item), { once: true });
          });

          // Mobile: activate all drawer images when drawer opens
          document.addEventListener('MobileNavDrawer:open', () => {
            const drawer = document.querySelector('#MobileNavDrawer');
            if (drawer) this.activate(drawer);
          });
        }
      };

      // === MEGA MENU CENTERING ===
      const MegaMenu = {
        init() {
          document.querySelectorAll('.mega-menu-container').forEach(container => {
            if (!container.querySelector('.mega-card')) {
              container.classList.add('no-cards');
            }
          });
        }
      };

      // === INITIALIZATION ===
      $(document).ready(() => {
        // Menu state handlers
        $('.menu-label-first').on('click', function() {
          const menuLabel = $(this).attr('menulable');
          if (menuLabel) MenuState.saveFirst(menuLabel);
        });

        $('.childer-title').on('click', function() {
          const menuLabel = $(this).attr('second-level-title');
          if (menuLabel) MenuState.saveSecond(menuLabel);
        });

        // Clear handlers
        $('.site-header__button__first-level, .backtop-first-level').on('click', () => {
          MenuState.saveFirst(' ');
        });

        $('.back__top_second-level').on('click', () => {
          MenuState.saveSecond(' ');
        });

        $('.site-header__mobile .site-header__mobile-logo').on('click', () => {
          MenuState.clear();
        });

        // Navigation open handler - always clear state to start at main menu
        $('#header-open-nav').one('click', () => {
          MenuState.clear();
        });

        // Initialize components
        // AccountDropdown.init();
        MobileNav.init();
        MegaMenu.init();
        NavImageLoader.init();

        // Reset mobile nav drawer to main menu when opened
        document.addEventListener('MobileNavDrawer:open', () => {
          // Reset all submenu checkboxes to unchecked
          const submenuCheckboxes = document.querySelectorAll('input[id^="left-menu-item-"]');
          submenuCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
          });

          // Ensure main menu checkbox is checked
          const mainMenuCheckbox = document.getElementById('left-menu');
          if (mainMenuCheckbox) {
            mainMenuCheckbox.checked = true;
          }

          // Clear any saved menu state to prevent restoration
          MenuState.clear();
        });
      });

      // === CLEANUP ===
      window.NavigationSystem = {
        cleanup() {
          // Remove all event listeners comprehensively
          $(document).off('click keydown');
          $(window).off('resize orientationchange');
          $('.menu-label-first, .childer-title, .site-header__button__first-level, .backtop-first-level, .back__top_second-level, .site-header__mobile .site-header__mobile-logo, #header-open-nav').off();
          $('.site-header__destkop-account[js-account-dropdown-trigger]').off();

          // Clean up mobile nav event listeners
          if (MobileNav.mediaQuery && MobileNav.mediaQuery.removeEventListener) {
            MobileNav.mediaQuery.removeEventListener('change', MobileNav.handleMediaChange);
          }

          // Clear any stored references
          MobileNav.nav = null;
          MobileNav.mediaQuery = null;
        }
      };
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNavigationSystem);
    } else {
      initNavigationSystem();
    }

    // Cleanup on page hide (bfcache-friendly)
    window.addEventListener('pagehide', () => {
      if (window.NavigationSystem) {
        window.NavigationSystem.cleanup();
      }
    });

  })();
